interface AnimalCardWrapperProps {
  onClick?: () => void
  children: React.ReactNode
}

const AnimalCardWrapper: React.FC<AnimalCardWrapperProps> = ({
  onClick,
  children,
}) => {
  return (
    <div
      className={
        "fp-border mb-[10px] flex gap-[10px] overflow-hidden rounded-[15px] bg-white p-[10px]"
      }
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default AnimalCardWrapper
